import serviceWorkerActionTypes from 'redux/service-workers/types';

const INITIAL_STATE = {
  serviceWorkerInitialized: false,
  serviceWorkerUpdated: false,
  serviceWorkerRegistration: null,
};

function serviceWorkerReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case serviceWorkerActionTypes.INITIALIZE_SERVICE_WORKER:
      return {
        ...state,
        serviceWorkerInitialized: true,
      };
    case serviceWorkerActionTypes.UPDATE_SERVICE_WORKER:
      return {
        ...state,
        serviceWorkerUpdated: !state.serviceWorkerUpdated,
        serviceWorkerRegistration: payload,
      };
    default:
      return state;
  }
}

export default serviceWorkerReducer;
